import * as React from 'react';
import { SocialLink } from '../../../Common/SocialLink';
const facebookIconUrl = require('../../../../icons/facebook.svg');
const emailIconUrl = require('../../../../icons/email.svg');
const twitterIconUrl = require('../../../../icons/twitter.svg');
import './style.css';

export interface ShareButtonsProps {
  /* empty */
  url: string;
  title: string;
}

export interface ShareButtonsState {
  /* empty */
}

export class ShareButtons extends React.Component<
  ShareButtonsProps,
  ShareButtonsState
> {
  render() {
    return (
      <div className="share-buttons">
        <SocialLink icon={emailIconUrl} text="Email" url={this.getEmailUrl()} />
        <SocialLink
          icon={facebookIconUrl}
          target="_blank"
          text="Facebook"
          url={this.getFacebookUrl()}
        />
        <SocialLink
          icon={twitterIconUrl}
          target="_blank"
          text="Twitter"
          url={this.getTwitterUrl()}
        />
      </div>
    );
  }

  private getEmailUrl = (): string => {
    const { title, url } = this.props;

    return (
      'mailto:' +
      this.toQueryString({
        subject: title,
        // TODO: Add hashtags?
        body: url
      })
    );
  };

  private getFacebookUrl = (): string => {
    const { title, url } = this.props;

    // TODO: Migrate to new API? https://stackoverflow.com/a/22969530
    return (
      'https://www.facebook.com/sharer/sharer.php' +
      this.toQueryString({
        u: url,
        quote: title
      })
    );
  };

  private getTwitterUrl = (): string => {
    const { title, url } = this.props;

    return (
      'https://twitter.com/share' +
      this.toQueryString({
        url,
        text: title,
        via: 'edgeofplay',
        // TODO: What should go here? Video tags? (Send multiple as CSV)
        hashtags: 'edgeofplay'
      })
    );
  };

  private toQueryString = (params: Object): string => {
    const encodedParams: Array<string> = [];

    for (let key of Object.keys(params)) {
      encodedParams.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      );
    }

    return encodedParams.length ? `?${encodedParams.join('&')}` : '';
  };
}

export default ShareButtons;



// WEBPACK FOOTER //
// ./src/app/components/Common/ShareDialog/ShareButtons/index.tsx